(function () {
  'use strict';

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    if (args[0] && typeof args[0] === 'string' && 
        (args[0].includes('/cart/add') || args[0].includes('/cart/change'))) {
      setTimeout(() => {
        addDiscountMessages();
      }, 2000);
    }
    return originalFetch.apply(this, args);
  };

  function addDiscountMessages() {
    const priceLists = document.querySelectorAll('price-list[data-hulkapps-lineitem]');
    
    priceLists.forEach(priceList => {
      const hasDiscountedPrice = priceList.querySelector('.discounted_price');
      const hasCustomMessage = priceList.querySelector('.custom-discount-message');
      
      if (hasDiscountedPrice && !hasCustomMessage) {
        const cartItem = priceList.closest('[data-line-key]') || priceList.closest('.cart-item, .cart__item, [class*="cart"]');
        const quantityInput = cartItem ? cartItem.querySelector('input.quantity-selector__input[type="number"]') : null;
        
        const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
        
        const discountPercent = quantity === 2 ? '15%' : '20%';
        
        const discountMsg = document.createElement('div');
        discountMsg.className = 'custom-discount-message';
        discountMsg.textContent = `-${discountPercent}`;
        discountMsg.style.cssText = 'color:rgb(28, 28, 28); font-weight: 400; margin-top: 4px; font-size: 0.875rem; background-color: #e2e2e2; padding: 4px 8px; border-radius: 6px;';
        
        priceList.appendChild(discountMsg);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addDiscountMessages);
  } else {
    addDiscountMessages();
  }

  window.addEventListener('load', addDiscountMessages);

})();